export const safecheckFr = {
  filter: "Filtrer",
  reset: "Réinitialiser",
  search: "Rechercher",
  print: "Imprimer",
  back: "Retour",
  cancel: "Annuler",
  filters: "Filtres de recherche",
  show: "Afficher",
  entries: "éléments",
  items: "élément(s)",
  searchLabel: "Rechercher :",
  tablePagination: {
    showing: "Affichage de",
    to: "à",
    of: "sur",
    entries: "entrées",
    previous: "Précédente",
    next: "Suivante",
  },
  status: { active: "ACTIF", inactive: "INACTIF" },
  columns: { status: "STATUT", actions: "ACTIONS" },
  fields: {
    company: "ENTREPRISE",
    province: "PROVINCE",
    branch: "ANTENNE",
    systemId: "ID SYSTÈME",
    status: "STATUT",
  },
  nav: {
    dashboard: "Dashboard",
    management: "GESTION",
    structure: "STRUCTURE",
    packagesSection: "FORFAITS & CONVENTIONS",
    systemSection: "SYSTÈME",
    proforma: "Proforma",
    consultation: "CONSULTATION",
    authorizations: "AUTORISATIONS",
    configuration: "CONFIGURATION",
    operations: "OPÉRATIONS",
    users: "Utilisateurs",
    allAccounts: "Tous les comptes",
    addUser: "Ajouter un utilisateur",
    providers: "Prestataires",
    allProviders: "Tous les prestataires",
    addProvider: "Ajouter un prestataire",
    employees: "Employés",
    allEmployees: "Tous les employés",
    addEmployee: "Ajouter un employé",
    beneficiaries: "Bénéficiaires",
    branches: "Antennes",
    acts: "Actes & Diagnostics",
    actsOverview: "Actes & Diagnostics",
    consultActs: "Consulter les actes",
    consultDiagnostics: "Consulter les diagnostics",
    standardActCodes: "Codes standards - Actes",
    standardDiagnosticCodes: "Codes standards - Diagnostics",
    hospitalActs: "Actes par hôpital",
    pharmacyCatalog: "Catalogue pharmacie",
    categoryValidation: "Validation catégories",
    admissions: "Admissions",
    invoices: "Factures",
    submitInvoice: "Soumettre une facture",
    pendingInvoices: "Factures en attente d'audit",
    allInvoices: "Toutes les factures",
    approvedInvoices: "Factures approuvées",
    approvedInvoicesToPay: "Approuvées (payer)",
    rejectedInvoices: "Factures rejetées",
    auditedInvoices: "Factures auditées",
    statistics: "Statistiques",
    globalStatistics: "Statistiques globales",
    packages: "Packages",
    allPackages: "Tous les packages",
    createPackage: "Créer un package",
    conventions: "Conventions",
    allConventions: "Toutes les conventions",
    createConvention: "Nouvelle convention",
    budgetConsumption: "Consommation budget",
    requests: "Demandes d'autorisation",
    companyBilling: "Facturation entreprise",
    allCompanyBilling: "Tous les relevés",
    createCompanyBilling: "Nouveau relevé",
    exchangeRates: "Taux de change",
    backup: "Sauvegarde",
    createBackup: "Créer une sauvegarde",
    restoreBackup: "Restauration",
    systemLogs: "Logs système",
    cacheManagement: "Gestion du cache",
    settings: "Paramètres",
    adminDashboard: "Dashboard Admin",
    auditorDashboard: "Tableau de bord",
    auditSection: "AUDIT",
    requestsToValidate: "Demandes à valider",
    hospitalDashboard: "Tableau de bord",
    disputes: "Litiges",
    admissionList: "Liste des admissions",
    newAdmission: "Nouvelle admission",
    allAdmissions: "Toutes les admissions",
    allDisputes: "Tous les litiges",
    createDispute: "Créer un litige",
    inProgressDisputes: "Litiges en cours",
    processedDisputes: "Litiges traités",
    allAuditReports: "Tous les rapports",
    submitAuditReport: "Soumettre un rapport",
    auditReports: "Rapports d'audit",
    viewInvoices: "Consulter les factures",
    enterpriseDashboard: "Tableau de bord",
    generateInvoice: "Facture globale",
    employeeManagement: "Gestion employés",
    employeeList: "Liste employés",
    beneficiaryList: "Liste bénéficiaires",
    communication: "COMMUNICATION",
    messaging: "Messagerie",
    userProfile: "Profil utilisateur",
    companyProfile: "Profil entreprise",
    providerProfile: "Profil prestataire",
    medicalActs: "Actes médicaux",
    diagnostics: "Diagnostics établissement",
  },
  login: {
    platform: "Plateforme de gestion des soins de santé",
    title: "Bon retour !",
    subtitle: "Connectez-vous pour accéder à votre espace",
    email: "ADRESSE EMAIL",
    password: "MOT DE PASSE",
    remember: "Se souvenir de moi",
    forgotPassword: "Mot de passe oublié ?",
    submit: "Se connecter",
    secure: "Sécurisé & Confidentiel",
    access: "Accès 24/7",
    demo: "Accéder en mode démo →",
    tagline: "Gestion simplifiée",
    backToHome: "Retour à l'accueil",
  },
  startup: {
    loading: "Chargement en cours…",
    platform: "Plateforme de gestion des soins de santé",
  },
  accountType: {
    title: "Choisissez votre type de compte",
    subtitle: "Sélectionnez l'espace correspondant à votre rôle pour accéder au bon tableau de bord.",
    accountLabel: "Type de compte",
    placeholder: "Sélectionnez un type de compte",
    continue: "Continuer",
    selected: "Sélectionné",
    backToLogin: "Retour à la connexion",
    types: {
      admin: {
        title: "Administrateur",
        description: "Gestion complète de la plateforme : utilisateurs, prestataires, forfaits et autorisations.",
      },
      auditor: {
        title: "Auditeur",
        description: "Examen des factures, rapports d'audit et gestion des litiges.",
      },
      hospital: {
        title: "Prestataire de soins",
        description: "Tableau de bord hôpital : admissions, factures et revenus du mois.",
      },
      enterprise: {
        title: "Entreprise",
        description: "Vue entreprise : employés, ayants droits, dépenses et admissions.",
      },
    },
  },
  dashboard: {
    welcome: "Bienvenue dans votre tableau de bord.",
    adminWelcome: "Hello slutala",
    auditorWelcome: "Salut elviskatuala",
    hospitalWelcome: "Medecin de nuit",
    enterpriseWelcome: "CENTRE D'EXPERTISE D'EVALUATION ET DE CERTIFICATION (CEEC)",
    stats: {
      admin: {
        allInvoices: "Toutes les factures",
        submittedInvoices: "Factures soumises",
        reviewInvoices: "Factures en examen",
        approvedInvoices: "Factures approuvées",
        paidInvoices: "Factures payées",
        admissions: "Admissions",
        modifyInvoices: "Factures à modifier",
        validationRequests: "Demandes de validation",
      },
      auditor: {
        allInvoices: "Toutes les factures",
        submittedInvoices: "Factures soumises",
        reviewInvoices: "Factures en examen",
        approvedInvoices: "Factures approuvées",
        paidInvoices: "Factures payées",
        modifyInvoices: "Factures à modifier",
        validationRequired: "Demandes à valider",
      },
      hospital: {
        allInvoices: "Toutes les factures",
        submittedInvoices: "Factures soumises",
        paidInvoices: "Factures payées",
        reviewInvoices: "Factures en examen",
        approvedInvoices: "Factures approuvées",
        rejectedInvoices: "Factures rejetées",
        monthlyRevenue: "Revenus du mois",
      },
      enterprise: {
        allInvoices: "Toutes les factures",
        approvedInvoices: "Factures approuvées",
        monthlyExpenses: "Dépenses du mois",
        totalAgents: "Agents total",
        todayAdmissions: "Admissions du jour",
        hfInvoices: "Factures HF",
        beneficiaries: "Ayants droits",
      },
    },
    enterpriseBoard: {
      pageTitle: "Tableau de bord",
      subtitle:
        "Historique complet · budget {budget} USD — prévision {year} · {beneficiaries} bénéficiaires",
      filterDisclaimer:
        "Factures filtrées sur la période de facturation (début de facture) ; admissions sur la date d'admission ; effectif à la date de fin du filtre. Montants = facturé client (après réfraction).",
      filters: {
        from: "DU",
        to: "AU",
        hospital: "HÔPITAL",
        apply: "Filtrer",
        fullHistory: "HISTORIQUE COMPLET",
        allHospitals: "Tous les hôpitaux",
      },
      sections: {
        synthesis: "SYNTHÈSE",
        invoicesAdmissions: "FACTURES & ADMISSIONS",
        quickAccess: "ACCÈS RAPIDES",
        statistics: "STATISTIQUES",
      },
      quickAccess: {
        admissions: "Admissions",
        invoices: "Factures",
        agents: "Agents",
        beneficiaries: "Bénéficiaires",
      },
      visitDistribution: {
        title: "Répartition des visites (Top 5)",
        viewAll: "Voir tout",
        agents: "Agents",
        spouses: "Conjoints",
        children: "Enfants",
      },
      pathologies: {
        title: "Pathologies fréquentes (Top 5)",
        viewAll: "Voir tout",
      },
      careTypes: {
        title: "Répartition par type de soin (Top 6)",
        subtitle: "Hors forfait · factures approuvées / payées",
        viewAll: "Voir tout",
        columns: {
          type: "TYPE",
          quantity: "QUANTITÉ",
          price: "PRIX",
        },
        rows: {
          pharmacy: "Pharmacie",
          nursing: "Nursing",
          imagingLab: "Imagerie, Labo et Diagnostic",
          consultation: "Consultation (générale, spécialisée)",
          surgery: "Chirurgie",
          rehabilitation: "Support et rééducation",
        },
      },
      agePyramid: {
        title: "Pyramide d'âge",
        subtitle: "Effectif - date de naissance",
        viewAll: "Voir tout",
      },
      budget: {
        title: "Budget",
        allocated: "Budget alloué",
        annualForecast: "Prévision annuelle 2026",
        periodRange: "Du {start} au {end}",
        cumulative: "Consommation cumul.",
        cumulativeOn: "Au {date}",
        outOfPackage: "Cumul. hors forfait",
        outOfPackageOn: "Au {date}",
      },
      averageConsumption: {
        title: "Consommation moyenne",
        subtitle: "Fréquentation et montants moyens",
        attendanceRate: "Fréquentation moyenne",
        amountPerAdmission: "Par admission",
        amountPerAgent: "Par agent",
        admittedAgents: "Agents admis",
      },
      workforce: {
        title: "Effectif",
        subtitle: "Liste de bénéficiaires",
        total: "Total",
        agents: "Agents",
        spouses: "Conjoints",
        children: "Enfants",
      },
      attendance: {
        title: "Fréquentation",
        subtitle: "Ayant été admis au moins 1 fois",
        total: "Total",
        agents: "Agents",
        spouses: "Conjoints",
        children: "Enfants",
      },
      metrics: {
        admissions: "Admissions",
        allInvoices: "Toutes les factures",
        outOfPackageInvoices: "Factures hors-forfait",
        inProgress: "En cours de traitement",
        validated: "Factures validées",
        savings: "Économie générée",
        savingsRequested: "Demandé",
        savingsValidated: "Validé",
        savingsGap: "Écart",
        dailyAttendance: "Fréquentation du jour",
      },
    },
    enterpriseAnalytics: {
      visits: {
        title: "Répartition des visites",
        subtitleFallback: "Historique complet",
        back: "Retour au tableau de bord",
        loading: "Chargement…",
        empty: "Aucune admission sur la période.",
        beneficiary: "Bénéficiaire",
        visits: "Visites",
      },
      agePyramid: {
        title: "Pyramide d'âge — détail",
        subtitleFallback: "Historique complet",
        back: "Retour au tableau de bord",
        loading: "Chargement…",
        empty: "Aucun bénéficiaire trouvé.",
        summary:
          "Effectif au {date} · {withBirthdate} bénéficiaire(s) avec date de naissance · {withoutBirthdate} sans date de naissance valide",
        columns: {
          beneficiary: "Bénéficiaire",
          type: "Type",
          employee: "Agent rattaché",
          birthdate: "Naissance",
          age: "Âge",
          bucket: "Tranche",
        },
      },
    },
    enterpriseAlerts: {
      invoiceValidated: {
        title: "Facture validée",
        message:
          "La facture #12 (Medecin de nuit) a été validée et est disponible dans Approuvées (payer).",
      },
      budgetCumulative: {
        title: "Alerte budget",
        message:
          "La consommation cumulée atteint 59,5 % du budget annuel 2026 ($424 594 / $713 400).",
      },
      budgetOutOfPackage: {
        title: "Alerte budget hors forfait",
        message:
          "La consommation hors forfait s'élève à 12,2 % ($86 724). Surveillez les dépenses non couvertes.",
      },
    },
    hospitalBoard: {
      pageTitle: "Tableau de bord",
      subtitle: "{invoices} factures · {revenue} revenus du mois",
      sections: {
        indicators: "Indicateurs clés",
        quickAccess: "Accès rapides",
        charts: "Analyses",
        clients: "Factures & clients",
      },
      indicators: {
        invoices: "Toutes les factures",
        submitted: "Factures soumises",
        paid: "Factures payées",
        review: "En examen",
        approved: "Factures approuvées",
        rejected: "Factures rejetées",
        revenue: "Revenus du mois",
      },
      indicatorFooters: {
        cumulative: "Total cumulé",
        pending: "En attente",
        settled: "$ Réglées",
        inProgress: "En cours",
        validated: "Validées",
        toFix: "À corriger",
        thisMonth: "Ce mois",
      },
      quickActions: {
        admission: "Admission",
        submit: "Soumettre",
        invoices: "Factures",
        admissions: "Admissions",
      },
      invoiceDistribution: {
        title: "Répartition des factures",
        labels: {
          submitted: "Soumises",
          review: "En examen",
          approved: "Approuvées",
          paid: "Payées",
          rejected: "Rejetées",
        },
      },
      financials: {
        title: "Indicateurs financiers",
        totalBilled: "Montant total facturé",
        paid: "Montant payé",
        pending: "Montant en attente",
        validationRate: "Taux de validation",
      },
      topClients: {
        title: "Top 5 Entreprises Clientes",
        columns: {
          company: "ENTREPRISE",
          invoices: "FACTURES",
          totalAmount: "MONTANT TOTAL",
        },
      },
      filters: {
        search: "RECHERCHER",
        searchPlaceholder: "Rechercher par ID, entreprise...",
        company: "ENTREPRISE",
        allCompanies: "Toutes les entreprises",
        from: "À PARTIR DU",
        to: "JUSQU'AU",
        reset: "Réinitialiser",
      },
      submittedInvoices: {
        title: "Factures soumises (100 dernières)",
        show: "Afficher",
        entries: "entrées",
        search: "Rechercher :",
        urgent: "URGENT",
        submitted: "SOUMISE",
        download: "Télécharger la facture",
        view: "Voir la facture",
        previous: "Précédente",
        next: "Suivante",
        pagination: "Affichage de {from} à {to} sur {total} entrées",
        columns: {
          id: "ID",
          company: "ENTREPRISE",
          amount: "MONTANT",
          submittedDate: "DATE SOUMISSION",
          delay: "DÉLAI",
          priority: "PRIORITÉ",
          status: "STATUT",
          invoice: "FACTURE",
          actions: "ACTIONS",
        },
      },
    },
    auditorBoard: {
      pageTitle: "Tableau de bord",
      subtitle: "{invoices} factures à auditer · {requests} demandes en attente",
      sections: {
        indicators: "Indicateurs clés",
        quickAccess: "Accès rapides",
        charts: "Analyses",
        invoices: "Factures soumises",
      },
      indicators: {
        invoices: "Toutes les factures",
        submitted: "Factures soumises",
        review: "En examen",
        approved: "Factures approuvées",
        paid: "Factures payées",
        rejected: "Factures rejetées",
        validation: "Demandes à valider",
      },
      indicatorFooters: {
        cumulative: "Total cumulé",
        pending: "En attente",
        settled: "$ Réglées",
        inProgress: "En cours",
        validated: "Validées",
        toFix: "À corriger",
      },
      quickActions: {
        toAudit: "À auditer",
        approved: "Approuvées",
        rejected: "Rejetées",
        admissions: "Admissions",
      },
      invoiceDistribution: {
        title: "Répartition des factures",
        labels: {
          submitted: "Soumises",
          review: "En examen",
          approved: "Approuvées",
          paid: "Payées",
          modify: "À modifier",
        },
      },
      productivity: {
        title: "Indicateurs de productivité",
        auditedToday: "Factures auditées aujourd'hui",
        avgAuditTime: "Temps moyen d'audit",
        pendingOver48h: "Factures en attente +48h",
      },
      filters: {
        search: "Rechercher",
        searchPlaceholder: "Rechercher par ID, hôpital, entreprise...",
        hospital: "Hôpital",
        allHospitals: "Tous les hôpitaux",
        company: "Entreprise",
        allCompanies: "Toutes les entreprises",
        from: "À partir du",
        to: "Jusqu'au",
        reset: "Réinitialiser",
      },
      submittedInvoices: {
        title: "Factures soumises (100 dernières)",
        show: "Afficher",
        entries: "entrées",
        search: "Rechercher :",
        urgent: "URGENT",
        normal: "NORMAL",
        submitted: "SOUMISE",
        previous: "Précédente",
        next: "Suivante",
        pagination: "Affichage de {from} à {to} sur {total} entrées",
        columns: {
          id: "ID",
          hospital: "HÔPITAL",
          company: "ENTREPRISE",
          amount: "MONTANT",
          submittedDate: "DATE SOUMISSION",
          delay: "DÉLAI",
          priority: "PRIORITÉ",
          status: "STATUT",
        },
      },
    },
  },
  adminDashboard: {
    pageTitle: "Tableau de bord",
    summary: "{invoices} factures · {admissions} admission(s) aujourd'hui",
    badge: "Administration",
    sections: {
      quickAccess: "Accès rapides",
      charts: "Analyses",
      activity: "Activité & plateforme",
      invoices: "Factures soumises",
    },
    keyIndicators: "Indicateurs clés",
    admissionsTrend: "Tendance des admissions",
    admissionsLabel: "Admissions",
    invoiceOverview: "Statut des factures",
    requestsOverview: "Demandes d'autorisation",
    totalRequests: "demandes au total",
    platformMetrics: "Vue d'ensemble plateforme",
    recentActivity: "Activité récente",
    ago: "il y a",
    invoiceStatus: {
      submitted: "Soumises",
      review: "En examen",
      approved: "Approuvées",
      paid: "Payées",
      modify: "À modifier",
    },
    requestStatus: {
      pending: "En attente",
      approved: "Approuvées",
      rejected: "Rejetées",
    },
    metrics: {
      providers: "Prestataires",
      employees: "Employés",
      beneficiaries: "Bénéficiaires",
      packages: "Packages actifs",
    },
    activities: {
      admission: "Nouvelle admission enregistrée",
      invoice: "Facture soumise pour examen",
      request: "Demande d'autorisation reçue",
      employee: "Nouvel employé ajouté",
      package: "Package mis à jour",
    },
    indicators: {
      totalInvoices: "Factures totales",
      inReview: "En examen",
      approved: "Approuvées",
      admissions: "Admissions du jour",
    },
    indicatorFooters: {
      cumulative: "Cumul 2026",
      toProcess: "À traiter",
      validated: "Validées",
      inProgress: "{count} en cours",
      today: "Aujourd'hui",
    },
    quickLinks: {
      invoices: "Factures",
      admissions: "Admissions",
      users: "Utilisateurs",
      providers: "Prestataires",
      conventions: "Conventions",
      logs: "Journaux",
    },
    invoiceDistribution: {
      title: "Répartition des factures",
      labels: {
        submitted: "Soumises",
        review: "En examen",
        approved: "Approuvées",
        paid: "Payées",
        modify: "À modifier",
      },
    },
    monthlyVolume: {
      title: "Volume mensuel (6 derniers mois)",
    },
    systemStats: {
      title: "Statistiques du système",
      labels: {
        hospitals: "Hôpitaux actifs",
        companies: "Entreprises actives",
        auditors: "Auditeurs actifs",
        validationRate: "Taux de validation",
      },
    },
    submittedInvoices: {
      title: "Factures soumises (100 dernières)",
      show: "Afficher",
      entries: "entrées",
      search: "Rechercher :",
      urgent: "URGENT",
      submitted: "SOUMISE",
      download: "Télécharger la facture",
      previous: "Précédente",
      next: "Suivante",
      pagination: "Affichage de {from} à {to} sur {total} entrées",
      columns: {
        id: "ID",
        hospital: "HÔPITAL",
        company: "ENTREPRISE",
        amount: "MONTANT",
        submittedDate: "DATE SOUMISSION",
        delay: "DÉLAI",
        priority: "PRIORITÉ",
        status: "STATUT",
        invoice: "FACTURE",
      },
    },
  },
  employees: {
    title: "Liste des employés",
    add: "Ajouter un employé",
    columns: {
      photo: "PHOTO",
      name: "NOM",
      systemId: "ID SYSTÈME",
      matricule: "MATRICULE ENTREPRISE",
      company: "ENTREPRISE",
      province: "PROVINCE",
      branch: "ANTENNE",
      status: "STATUT",
    },
    create: {
      title: "Ajouter un employé",
      backToList: "Retour à la liste",
      cardTitle: "Enregistrer un employé",
      submit: "Créer l'employé",
      fields: {
        fullName: "NOM COMPLET",
        companyMatricule: "MATRICULE (ENTREPRISE)",
        birthDate: "DATE DE NAISSANCE",
        gender: "SEXE",
        company: "ENTREPRISE",
        assignedHospital: "HÔPITAL AFFECTÉ",
        position: "POSITION",
        phone: "TÉLÉPHONE",
        email: "EMAIL",
        city: "VILLE",
        province: "PROVINCE",
      },
      placeholders: {
        fullName: "Ex: Jean Dupont",
        companyMatricule: "Matricule interne",
        birthDate: "jj/mm/aaaa",
        gender: "--Sélectionner--",
        company: "--Sélectionner --",
        assignedHospital: "--Aucun--",
        position: "--Sélectionner --",
        phone: "+243 XXX XXX XXX",
        email: "email@exemple.com",
        city: "Kinshasa",
        province: "--Sélectionner --",
      },
    },
    enterpriseList: {
      empty: "Aucun employé trouvé",
      columns: {
        photo: "Photo",
        name: "Nom",
        systemId: "ID Système",
        matricule: "Matricule entreprise",
        branch: "Antenne",
        province: "Province",
        status: "Statut",
      },
      statuses: {
        active: "ACTIF",
        inactive: "INACTIF",
      },
      pagination: {
        showing: "Affichage de",
        to: "à",
        of: "sur",
        entries: "entrées",
        previous: "Précédente",
        next: "Suivante",
      },
    },
  },
  branchesPage: {
    pageTitle: "Gestion des Antennes",
    listTitle: "Liste des Antennes",
    newBranch: "Nouvelle Antenne",
    search: "RECHERCHER",
    searchPlaceholder: "Nom, province...",
    allStatuses: "Tous les statuts",
    columns: {
      name: "NOM DE L'ANTENNE",
      province: "PROVINCE",
      phone: "TÉLÉPHONE",
      email: "EMAIL",
      status: "STATUT",
      actions: "ACTIONS",
    },
    actions: {
      edit: "Modifier",
      deactivate: "Désactiver",
      delete: "Supprimer",
    },
    create: {
      title: "Créer une Antenne",
      cardTitle: "Nouvelle Antenne",
      submit: "Enregistrer",
      fields: {
        name: "NOM DE L'ANTENNE",
        province: "PROVINCE",
        address: "ADRESSE",
        phone: "TÉLÉPHONE",
        email: "EMAIL",
        status: "STATUT",
      },
      placeholders: {
        name: "Ex: Kinshasa Centre",
        province: "-- Sélectionner --",
        address: "Adresse complète de l'antenne",
        phone: "Ex: +243 XX XXX XXXX",
        email: "email@exemple.com",
      },
    },
  },
  usersPage: {
    title: "Utilisateurs",
    addUser: "Ajouter un utilisateur",
    exportCsv: "Exporter CSV",
    create: {
      formTitle: "Nouveau compte utilisateur",
      backToList: "Retour a la liste",
      roleHint: "Definit les permissions de l'utilisateur",
      passwordHint: "Minimum 6 caracteres",
      chooseFile: "Selectionner un fichier",
      noFileSelected: "Aucun fichier sélectionné",
      fileHint: "Format accepte: JPG, PNG, GIF (Max 2MB)",
      submit: "Creer l'utilisateur",
      fields: {
        username: "NOM D'UTILISATEUR",
        email: "EMAIL",
        role: "ROLE",
        password: "MOT DE PASSE",
        profilePhoto: "PHOTO DE PROFIL",
      },
      placeholders: {
        username: "Prenom + Nom",
        email: "email@exemple.com",
        role: "-- Selectionner un role --",
        password: "Minimum 6 caracteres",
      },
    },
    filters: {
      role: "RÔLE",
      username: "NOM D'UTILISATEUR",
      email: "EMAIL",
      allRoles: "Tous les rôles",
      usernamePlaceholder: "Rechercher un nom...",
      emailPlaceholder: "Rechercher un email...",
    },
    table: {
      searchPlaceholder: "Rechercher dans le tableau...",
      columns: {
        id: "ID",
        name: "NOM",
        email: "EMAIL",
        role: "RÔLE",
        photo: "PHOTO",
        actions: "ACTIONS",
      },
    },
    roles: {
      admin: "Admin (Acces total)",
      auditor: "Auditeur (Verification)",
      enterprise: "Entreprise (Employes)",
      hospital: "Hopital (Soins)",
    },
  },
  providers: {
    title: "Prestataires de Soins",
    listTitle: "Liste des Prestataires",
    add: "Nouveau Prestataire",
    columns: { name: "NOM COMMERCIAL", type: "TYPE", city: "VILLE", contact: "CONTACT" },
    fields: { type: "TYPE DE PRESTATAIRE", city: "VILLE", cityPlaceholder: "Filtrer par ville..." },
    create: {
      title: "Créer un Prestataire",
      backToList: "Retour à la liste",
      cardTitle: "Informations du Prestataire",
      baseInfo: "Informations de base",
      locationInfo: "Localisation",
      contactInfo: "Informations de Contact",
      contactPersonInfo: "Personne de Contact",
      administrativeInfo: "Informations Administratives",
      specialtiesHint: "Séparez les spécialités par des virgules",
      submit: "Créer le prestataire",
      fields: {
        commercialName: "NOM COMMERCIAL",
        providerType: "TYPE DE PRESTATAIRE",
        description: "DESCRIPTION",
        address: "ADRESSE",
        city: "VILLE",
        province: "PROVINCE",
        postalCode: "CODE POSTAL",
        phone: "TÉLÉPHONE",
        email: "EMAIL",
        website: "SITE WEB",
        contactName: "NOM COMPLET",
        contactPhone: "NUMÉRO DE TÉLÉPHONE",
        contactEmail: "ADRESSE EMAIL",
        agreementNumber: "NUMÉRO D'AGRÉMENT",
        rccm: "RCCM",
        idNat: "ID NAT",
        specialties: "SPÉCIALITÉS",
        status: "STATUT",
      },
      placeholders: {
        commercialName: "Ex: Clinique du Faubourg",
        providerType: "-- Sélectionner --",
        description: "Décrivez brièvement le prestataire...",
        address: "Adresse complète...",
        city: "Ex: Kinshasa",
        province: "Ex: Kinshasa",
        postalCode: "Ex: 12345",
        phone: "+243 XX XXX XXXX",
        email: "contact@prestataire.com",
        website: "https://www.prestataire.com",
        contactName: "Ex: Jean Dupont",
        contactPhone: "+243 XX XXX XXXX",
        contactEmail: "jean.dupont@prestataire.com",
        agreementNumber: "Ex: AGR-2025-001",
        rccm: "Ex: RC-KIN/2025/12345",
        idNat: "Ex: 1-234-N56789K",
        specialties: "Ex: Cardiologie, Pédiatrie, Chirurgie (séparées par des virgules)",
      },
    },
  },
  beneficiaries: {
    title: "Liste des bénéficiaires",
    columns: {
      photo: "PHOTO",
      name: "NOM",
      relation: "RELATION",
      birthDate: "DATE DE NAISSANCE",
      gender: "SEXE",
      employee: "EMPLOYÉ",
      matricule: "MATRICULE",
    },
    fields: {
      relation: "RELATION",
      allRelations: "Toutes les relations",
      gender: "SEXE",
      allGenders: "Tous",
      birthDate: "DATE DE NAISSANCE",
      ageMin: "ÂGE MINIMUM",
      ageMax: "ÂGE MAXIMUM",
    },
    enterpriseList: {
      searchPlaceholder: "Rechercher...",
      exportCsv: "Exporter CSV",
      backToEmployees: "Liste des employés",
      empty: "Aucun bénéficiaire trouvé",
      columns: {
        photo: "Photo",
        name: "Nom",
        relation: "Relation",
        systemId: "ID Système",
        companyMatricule: "Matricule entreprise",
        company: "Entreprise",
      },
      pagination: {
        showing: "Affichage de",
        to: "à",
        of: "sur",
        entries: "entrées",
        previous: "Précédente",
        next: "Suivante",
      },
    },
  },
  admissions: {
    title: "Admissions",
    listTitle: "Liste des Admissions",
      create: {
      pageTitle: "Créer une nouvelle admission",
      backToList: "Retour à la liste",
      instructions:
        "Mode d'emploi : Saisissez ou scannez l'ID SYSTÈME du patient (ex: SFC0002), puis sélectionnez le patient à admettre (employé ou ayant droit).",
      step1Title: "Étape 1 : Identification du Patient",
      step2Title: "Étape 2 : Date et motif",
      systemIdLabel: "ID SYSTÈME (MATRICULE)",
      systemIdPlaceholder: "Ex: SFC0002",
      systemIdHint: "Saisissez le matricule ou scannez le QR code de la carte patient",
      search: "Rechercher",
      scanQrLabel: "SCANNER QR CODE",
      scanQrButton: "Scanner QR Code",
      noResults: "Aucun patient trouvé pour cet identifiant.",
      selectPatient: "Sélectionnez le patient à admettre :",
      scanUnavailable: "Le scanner QR sera disponible prochainement sur cet appareil.",
      dateLabel: "Date d'admission",
      motifLabel: "Motif (optionnel)",
      motifPlaceholder: "Ex: Consultation, urgence…",
      submit: "Créer l'admission",
    },
    exportCsv: "Exporter CSV",
    searchPlaceholder: "Rechercher...",
    columns: {
      date: "Date admission",
      patient: "Patient",
      type: "Type",
      hospital: "Hôpital",
      company: "Entreprise",
      status: "Statut",
      actions: "Actions",
    },
    fields: {
      dateFrom: "À partir du",
      dateFromHint: "Inclut ce jour et les suivants",
      dateTo: "Jusqu'au",
      dateToHint: "Inclut ce jour (laisser vide = pas de fin)",
      status: "Statut",
      patientType: "Type de patient",
      hospital: "Hôpital",
      company: "Entreprise",
      allStatuses: "Tous les statuts",
      allTypes: "Tous les types",
      allHospitals: "Tous les hôpitaux",
      allCompanies: "Toutes les entreprises",
    },
    patientTypes: {
      employee: "EMPLOYÉ",
      beneficiary: "AYANT DROIT",
    },
    statuses: {
      inProgress: "EN COURS",
      completed: "TERMINÉE",
      cancelled: "ANNULÉE",
    },
    empty: "Aucune admission trouvée",
    pagination: {
      showing: "Affichage de",
      to: "à",
      of: "sur",
      entries: "entrées",
      previous: "Précédente",
      next: "Suivante",
    },
    enterpriseList: {
      pageTitle: "Admissions (Entreprise)",
      searchPlaceholder: "Rechercher...",
      exportCsv: "Exporter CSV",
      empty: "Aucune admission trouvée",
      defaultMotif: "Admission SafeCheck",
      patientTypes: {
        employee: "Employé",
        beneficiary: "Ayant droit",
      },
      columns: {
        date: "Date admission",
        patient: "Patient",
        type: "Type",
        hospital: "Hôpital",
        status: "Statut",
        reason: "Motif",
        actions: "Actions",
      },
      actions: {
        view: "Voir",
      },
      pagination: {
        showing: "Affichage de",
        to: "à",
        of: "sur",
        entries: "entrées",
        previous: "Précédente",
        next: "Suivante",
      },
    },
    hospitalList: {
      pageTitle: "Admissions (Hôpital)",
      searchPlaceholder: "Rechercher...",
      exportCsv: "Exporter CSV",
      empty: "Aucune admission trouvée",
      patientTypes: {
        employee: "Employé",
        beneficiary: "Ayant droit",
      },
      columns: {
        date: "Date Admission",
        patient: "Patient",
        type: "Type",
        company: "Entreprise",
        status: "Statut",
        actions: "Actions",
      },
      actions: {
        view: "Voir",
      },
      pagination: {
        showing: "Affichage de",
        to: "à",
        of: "sur",
        entries: "entrées",
        previous: "Précédente",
        next: "Suivante",
      },
    },
  },
  messaging: {
    pageTitle: "Messagerie",
    subtitles: {
      enterprise:
        "Échange exclusive avec l'équipe Safecheck-RDC",
      hospital:
        "Échange avec l'équipe Safecheck-RDC et les auditeurs.",
      admin:
        "Communiquez avec tous les comptes de la plateforme.",
      auditor:
        "Échangez avec les prestataires de soins.",
    },
    searchPlaceholder: "Rechercher une conversation...",
    emptyList: "Aucune conversation trouvée",
    filters: {
      all: "Toutes",
      unread: "Non lues",
    },
    chat: {
      online: "En ligne",
      offline: "Hors ligne",
      placeholder: "Écrivez votre message...",
      send: "Envoyer",
      backToList: "Retour aux conversations",
      today: "Aujourd'hui",
      yesterday: "Hier",
      selectConversation: "Sélectionnez une conversation pour afficher les messages.",
    },
    floating: {
      minimize: "Réduire en fenêtre flottante",
      maximize: "Ouvrir la messagerie complète",
      collapse: "Réduire la fenêtre",
      expand: "Développer la conversation",
      close: "Fermer la fenêtre flottante",
      openInbox: "Ouvrir la messagerie",
    },
  },
  settingsPage: {
    userProfile: {
      pageTitle: "Profil utilisateur",
      badge: "ENTREPRISE",
      contactTitle: "Informations de contact",
      tabs: {
        information: "Informations",
        security: "Sécurité",
      },
      sections: {
        userAccount: "Compte utilisateur",
        companyInfo: "Informations de l'entreprise",
        profilePhoto: "Photo de profil",
        security: "Sécurité",
      },
      fields: {
        username: "Nom d'utilisateur",
        email: "Email",
        companyName: "Nom de l'entreprise",
        address: "Adresse",
        phone: "Téléphone",
        profilePhoto: "Changer la photo (optionnel)",
        currentPassword: "Mot de passe actuel",
        newPassword: "Nouveau mot de passe",
        confirmPassword: "Confirmer le mot de passe",
      },
      photoHint: "Format accepté : JPG, PNG. Taille max : 2MB",
      chooseFile: "Choisir un fichier",
      noFileSelected: "Aucun fichier choisi",
      save: "Enregistrer les modifications",
      reset: "Réinitialiser",
      updatePassword: "Mettre à jour le mot de passe",
      hospital: {
        badge: "PRESTATAIRE",
        sections: {
          providerInfo: "Informations du prestataire",
        },
        fields: {
          providerName: "Nom du prestataire",
        },
      },
    },
    companyProfile: {
      pageTitle: "Profil entreprise",
      sectionTitle: "Informations de l'entreprise",
      fields: {
        companyName: "Nom de l'entreprise",
        address: "Adresse",
        phone: "Téléphone",
      },
      save: "Enregistrer",
    },
    providerProfile: {
      pageTitle: "Profil prestataire",
      sectionTitle: "Informations du prestataire",
      fields: {
        providerName: "Nom du prestataire",
        address: "Adresse",
        phone: "Téléphone",
      },
      save: "Enregistrer",
    },
  },
  packages: {
    title: "Forfaits",
    listTitle: "Liste des Packages",
    add: "Nouveau Package",
    searchPlaceholder: "Rechercher...",
    exportCsv: "Exporter CSV",
    empty: "Aucun package trouvé",
    included: "INCLUS",
    excluded: "EXCLUS",
    columns: { code: "CODE", name: "NOM", hospital: "HÔPITAL", rate: "TARIF MENSUEL", period: "PÉRIODE", acts: "ACTES" },
    fields: {
      allStatuses: "Tous les statuts",
      allHospitals: "Tous les hôpitaux",
      allCompanies: "Toutes les entreprises",
      status: "STATUT",
      hospital: "HÔPITAL",
      company: "ENTREPRISE",
    },
    summary: { total: "Total Packages", active: "Actifs", draft: "Brouillons", suspended: "Suspendus" },
    pagination: {
      showing: "Affichage de",
      to: "à",
      of: "sur",
      entries: "entrées",
      previous: "Précédente",
      next: "Suivante",
    },
    create: {
      title: "Créer un Package",
      editTitle: "Modifier le Package",
      backToList: "Retour à la liste",
      cancel: "Annuler",
      back: "Retour",
      previous: "Précédent",
      nextActs: "Suivant : Sélectionner les actes",
      nextValidation: "Suivant : Validation",
      submit: "Créer le package",
      editSubmit: "Enregistrer les modifications",
      generalInfo: "Informations générales",
      requiredField: "Veuillez renseigner ce champ",
      steps: {
        information: "Informations",
        includedActs: "Actes inclus",
        validation: "Validation",
      },
      fields: {
        hospital: "HÔPITAL",
        company: "ENTREPRISE",
        name: "NOM DU PACKAGE",
        monthlyRate: "TARIF MENSUEL (USD)",
        periodStart: "DATE DÉBUT",
        periodEnd: "DATE FIN",
        description: "DESCRIPTION",
        status: "STATUT",
      },
      placeholders: {
        hospital: "-- Sélectionner un hôpital --",
        company: "-- Sélectionner une entreprise --",
        name: "Ex: Forfait Standard 2026",
        monthlyRate: "150000",
        periodStart: "jj/mm/aaaa",
        periodEnd: "jj/mm/aaaa",
        description: "Description générale du package...",
      },
      statuses: {
        draft: "Brouillon (à activer plus tard)",
        active: "Actif",
        suspended: "Suspendu",
      },
      includedActs: {
        title: "Sélectionner les actes inclus",
        instructions:
          "Instructions : Cochez les actes qui sont INCLUS dans le forfait. Les actes non cochés nécessiteront une autorisation préalable (hors forfait).",
        available: "Actes disponibles",
        included: "Actes inclus",
        outOfPackage: "Hors forfait",
        searchPlaceholder: "Rechercher un acte...",
        selectAll: "Tout sélectionner",
        deselectAll: "Tout désélectionner",
        selectedCount: "{selected} acte(s) sélectionné(s) sur {total}",
        emptyHospital: "Aucun acte trouvé pour cet hôpital.",
        limits: {
          toggle: "Limites (quantité / période / notes)",
          quantity: "Quantité max",
          quantityPlaceholder: "Ex : 5",
          period: "Période",
          periodNone: "—",
          perDay: "par jour",
          perWeek: "par semaine",
          perMonth: "par mois",
          perYear: "par an",
          notes: "Notes",
          notesPlaceholder: "Notes…",
        },
      },
      validation: {
        title: "Validation et création",
        readyMessage: "Votre package est prêt à être créé. Vérifiez les informations ci-dessous.",
        summary: "Récapitulatif",
        statistics: "Statistiques :",
        periodSeparator: "->",
        statusDraft: "BROUILLON (À ACTIVER PLUS TARD)",
        includedActsBadge: "{count} ACTES INCLUS (FORFAIT)",
        outOfPackageBadge: "{count} ACTES HORS FORFAIT",
        importantNotice:
          "Important : Une fois le package créé et activé, il sera utilisé automatiquement pour vérifier les demandes de proforma.",
        fields: {
          hospital: "Hôpital",
          company: "Entreprise",
          packageName: "Nom du package",
          monthlyRate: "Tarif mensuel",
          period: "Période",
          status: "Statut",
        },
      },
    },
  },
  conventions: {
    title: "Conventions",
    add: "Nouvelle Convention",
    listTitle: "Conventions",
    empty: "Aucune convention trouvée.",
    providersBadge: "{count} PRESTATAIRE(S)",
    validitySeparator: "->",
    summary: {
      total: "Total",
      active: "Actives",
      expiringSoon: "Expire bientôt",
      budgetAlerts: "Alertes budget",
    },
    fields: {
      status: "STATUT",
      company: "ENTREPRISE",
      provider: "PRESTATAIRE",
      allStatuses: "Tous les statuts",
      allCompanies: "Toutes les entreprises",
      allProviders: "Tous les prestataires",
    },
    columns: {
      code: "CODE",
      convention: "CONVENTION",
      company: "ENTREPRISE",
      providers: "PRESTATAIRES",
      type: "TYPE",
      validity: "VALIDITÉ",
      budget: "BUDGET",
      consumption: "CONSOMMATION",
      status: "STATUT",
      actions: "ACTIONS",
    },
    types: {
      forfaitaire: "FORFAITAIRE",
      tiers_payant: "TIERS PAYANT",
      remboursement: "REMBOURSEMENT",
      mixte: "MIXTE",
      a_la_facture: "TIERS PAYANT",
    },
    statuses: {
      active: "ACTIVE",
      expiring: "EXPIRE BIENTÔT",
      expired: "EXPIRÉE",
      draft: "BROUILLON",
      suspended: "SUSPENDUE",
      cancelled: "ANNULÉE",
    },
    view: {
      edit: "Modifier",
      backToList: "Retour à la liste",
      generalInfo: "Informations générales",
      budgetConsumption: "Budget & Consommation",
      financialParams: "Paramètres financiers",
      beneficiaryRules: "Règles ayants droit",
      code: "Code convention",
      company: "Entreprise",
      providers: "Prestataires couverts",
      noProviders: "Aucun prestataire associé",
      treatmentType: "Type de traitement",
      validity: "Période de validité",
      description: "Description",
      specialConditions: "Conditions spéciales",
      budgetTotal: "Budget total",
      monthlyForfait: "Forfait mensuel",
      consumed: "Consommé",
      remaining: "Restant",
      consumptionRate: "Taux de consommation",
      consumptionRateForfait: "Taux de consommation (mois en cours)",
      alertThreshold: "Seuil alerte",
      perFamily: "/ famille",
      globalForfait: "forfait global",
      providerRates: "{count} tarif(s) prestataire",
      maxChildAge: "Âge max enfant",
      maxStudentAge: "Âge max étudiant",
      maxSpouseAge: "Âge max conjoint",
      maxDependents: "Nb max ayants droit",
      coveredTypes: "Types couverts",
      noLimit: "Pas de limite",
      years: "ans",
      alertWarning: "Attention : le budget atteint le seuil d'alerte de {threshold}%.",
      budgetDepleted: "Budget épuisé ou forfait mensuel dépassé.",
      invoicesTitle: "Factures comptabilisées",
      invoicesPeriod: "Période {start} → {end}",
      invoicesCount: "{count} facture(s)",
      invoicesEmpty: "Aucune facture comptabilisée sur la période courante.",
      viewInvoice: "Voir",
      invoiceColumns: {
        reference: "Référence",
        provider: "Prestataire",
        period: "Période",
        nature: "Nature",
        status: "Statut",
        amount: "Montant USD",
        actions: "Actions",
        total: "Total consommé",
      },
    },
    create: {
      title: "Nouvelle convention",
      editTitle: "Modifier la convention",
      back: "Retour",
      backToList: "Retour à la liste",
      generalInfo: "Informations générales",
      contractingParties: "Parties contractantes",
      financialParams: "Paramètres financiers",
      personCeilingsTitle: "Plafonds par personne",
      familyCeilingsTitle: "Plafonds par famille (foyer)",
      beneficiaryRules: "Règles des ayants droit",
      providerForfaitSection: "Tarifs forfait par prestataire (USD / famille / mois)",
      cancel: "Annuler",
      submit: "Enregistrer la convention",
      requiredField: "Ce champ est obligatoire.",
      optional: "OPTIONNEL",
      fields: {
        title: "INTITULÉ DE LA CONVENTION",
        treatmentType: "TYPE DE TRAITEMENT",
        coverageUnit: "PRISE EN CHARGE BUDGÉTAIRE",
        startDate: "DATE DE DÉBUT",
        endDate: "DATE DE FIN",
        description: "DESCRIPTION",
        specialConditions: "CONDITIONS SPÉCIALES",
        company: "ENTREPRISE",
        coveredProviders: "PRESTATAIRES COUVERTS",
        coveredProvidersHint: "(SÉLECTION MULTIPLE)",
        providerForfait: "FORFAIT PRESTATAIRE",
        providerClientForfait: "FORFAIT FACTURÉ CLIENT",
        totalBudget: "BUDGET TOTAL (USD)",
        budgetPeriodicity: "PÉRIODICITÉ DU BUDGET",
        individualCeiling: "PLAFOND INDIVIDUEL (USD)",
        dailyCeiling: "PLAFOND JOURNALIER (USD)",
        monthlyCeiling: "PLAFOND MENSUEL (USD)",
        annualCeiling: "PLAFOND ANNUEL (USD)",
        familyDailyCeiling: "PLAFOND FOYER JOURNALIER (USD)",
        familyMonthlyCeiling: "PLAFOND FOYER MENSUEL (USD)",
        familyAnnualCeiling: "PLAFOND FOYER ANNUEL (USD)",
        monthlyPackageAmount: "MONTANT FORFAIT MENSUEL (USD) SI FORFAITAIRE",
        copayPct: "TICKET MODÉRATEUR (%)",
        globalBudgetAlertThreshold: "SEUIL D'ALERTE BUDGET GLOBAL (%)",
        individualAlertThreshold: "SEUIL D'ALERTE INDIVIDUEL (%)",
        childAgeLimit: "ÂGE LIMITE ENFANT",
        studentChildAgeLimit: "ÂGE LIMITE ENFANT ÉTUDIANT",
        spouseAgeLimit: "ÂGE LIMITE CONJOINT",
        maxDependentsPerEmployee: "NB MAX AYANTS DROIT / EMPLOYÉ",
        coveredDependentTypes: "TYPES D'AYANTS DROIT COUVERTS",
      },
      placeholders: {
        title: "Ex: Convention Santé Entreprise XYZ 2026",
        treatmentType: "--Choisir--",
        date: "jj/mm/aaaa",
        description: "Décrivez l'objet et le périmètre de cette convention...",
        specialConditions: "Clauses particulières, exclusions, etc.",
        company: "--Sélectionner une entreprise--",
        globalBudgetAlertThreshold: "80",
        individualAlertThreshold: "ex: 80",
        childAgeLimit: "21",
        studentChildAgeLimit: "26",
        spouseAgeLimit: "Pas de limite",
        maxDependentsPerEmployee: "5",
      },
      hints: {
        coveredProviders:
          "Maintenez Ctrl (Windows) ou ⌘ (Mac) pour sélectionner plusieurs prestataires.",
        providerForfaits:
          "Laissez vide pour utiliser le forfait global ou le package lié à l'hôpital.",
        globalBudgetAlert:
          "Alerte quand le budget global atteint ce seuil",
        individualAlert:
          "Alerte quand un employé atteint ce % de son plafond individuel",
        coverageUnit:
          "Détermine si les plafonds s'appliquent par personne, par famille, ou les deux.",
        budgetPeriodicity:
          "Période de reconduction de l'enveloppe budgétaire globale (calendaire).",
        personCeilings:
          "Compteurs propres à chaque bénéficiaire. Journalier ≤ mensuel ≤ annuel.",
        familyCeilings:
          "Un seul pot partagé employé + ayants droit. Journalier ≤ mensuel ≤ annuel.",
      },
      suffixes: {
        years: "ans",
        percent: "%",
      },
      dependentTypes: {
        spouse: "Conjoint",
        children: "Enfants",
        parents: "Parents",
        other: "Autres",
      },
      coverageUnits: {
        personne: "Par personne",
        famille: "Par famille",
        mixte: "Mixte (personne + famille)",
      },
      coverageUnitHints: {
        personne: "Chaque bénéficiaire a ses propres plafonds.",
        famille: "Employé + ayants droit partagent les mêmes plafonds foyer.",
        mixte: "Les deux s'appliquent : le plus restrictif bloque.",
      },
      budgetPeriodicities: {
        trimestriel: "Trimestriel",
        semestriel: "Semestriel",
        annuel: "Annuel",
      },
      budgetPeriodicityHints: {
        trimestriel: "Enveloppe reconduite chaque trimestre civil (Q1–Q4).",
        semestriel: "Enveloppe reconduite chaque semestre civil (S1–S2).",
        annuel: "Enveloppe reconduite chaque année civile.",
      },
      treatmentTypes: {
        forfaitaire: "FORFAITAIRE",
        tiers_payant: "TIERS PAYANT",
        remboursement: "REMBOURSEMENT",
        mixte: "MIXTE",
        a_la_facture: "TIERS PAYANT",
      },
    },
  },
  budgetConsumption: {
    title: "Consommation budget",
    subtitle:
      "Budget fixé par période (trimestriel / semestriel / annuel) vs somme des factures forfait mensuel + hors forfait.",
    backToConventions: "Retour conventions",
    filters: "Filtres",
    company: "Entreprise",
    allCompanies: "Toutes les entreprises",
    periodicity: "Périodicité (vue)",
    period: "Période",
    refresh: "Actualiser",
    hint: "La périodicité de chaque convention reste celle définie sur la convention ; le filtre périodicité sert à choisir les périodes affichées.",
    tableTitle: "Consommation ({count})",
    loading: "Chargement…",
    empty: "Aucune donnée pour cette sélection.",
    columns: {
      company: "Entreprise",
      convention: "Convention",
      period: "Période",
      budget: "Budget période",
      forfait: "Forfait mensuel",
      horsForfait: "Hors forfait",
      consumed: "Total consommé",
      pct: "%",
      status: "Statut",
      actions: "Actions",
    },
    status: {
      ok: "OK",
      alert: "Alerte",
      depleted: "Dépassé",
    },
    editBudget: "Modifier le budget de la période",
    saveBudget: "Enregistrer",
    cancelEdit: "Annuler",
    editSaved: "Budget de période enregistré.",
    editError: "Enregistrement impossible.",
    editInvalid: "Montant invalide.",
    openRevision: "Réviser",
    revisionTitle: "Révision budgétaire",
    revisionTab: "Nouvelle révision",
    historyTab: "Historique",
    natureLabel: "Enveloppe",
    effectiveFrom: "Date d'effet (ex. ouverture province)",
    suggestEffectif: "Calculer selon l'effectif",
    suggestLoading: "Calcul…",
    effectifBefore: "Effectif avant",
    effectifAfter: "Effectif après",
    suggestedDelta: "Ajustement suggéré",
    newBudget: "Nouveau budget",
    newAmountLabel: "Montant budget période (USD)",
    reasonLabel: "Motif / commentaire",
    reasonPlaceholder: "Ex. Extension Kinshasa — +120 familles depuis janvier",
    saveRevision: "Enregistrer la révision",
    saving: "Enregistrement…",
    revisionSaved: "Révision budgétaire enregistrée.",
    historyEmpty: "Aucune révision pour cette période.",
  },
  requests: {
    title: "Demandes d'Autorisation",
    add: "Nouvelle Demande",
    listTitle: "Liste des Demandes",
    filtersTitle: "Filtres",
    searchPlaceholder: "Rechercher...",
    exportCsv: "Exporter CSV",
    empty: "Aucune demande trouvée.",
    urgency: { normal: "NORMAL", urgent: "URGENT", emergency: "Urgence vitale" },
    status: { pending: "EN ATTENTE", approved: "APPROUVÉE", rejected: "REJETÉE" },
    createForm: {
      systemIdSearch: "Recherche par ID SYS (optionnel)",
      systemIdPlaceholder: "ID SYS (ex: SFC0171)",
      systemIdRequired: "Saisissez un ID SYS.",
      patientType: "Patient concerné",
      patientEmployee: "Employé principal",
      patientDependent: "Ayant droit",
      dependentName: "Ayant droit",
      dependentPlaceholder: "Sélectionnez un ayant droit",
      noDependents: "Aucun ayant droit enregistré pour cet employé.",
      loadingDependents: "Chargement des ayants droit…",
      actsTitle: "Actes demandés",
      actsHint: "Ajoutez les actes de la grille tarifaire de l'hôpital.",
      addAct: "Ajouter un acte",
      actSearch: "Rechercher un acte (code ou libellé)",
      noActs: "Aucun acte ajouté.",
      selectHospitalFirst: "Sélectionnez d'abord l'hôpital pour voir les actes.",
      quantity: "Qté",
      unitPrice: "Prix unitaire (USD)",
      lineTotal: "Total",
      estimatedAmount: "Montant total estimé (USD)",
      estimatedHint: "Calculé automatiquement à partir des actes ajoutés.",
      urgencyLevel: "Niveau d'urgence",
      actsRequired: "Ajoutez au moins un acte à la demande.",
      dependentRequired: "Sélectionnez l'ayant droit dans la liste.",
    },
    columns: {
      id: "ID",
      patient: "PATIENT",
      package: "PACKAGE",
      hospital: "HÔPITAL",
      company: "ENTREPRISE",
      urgency: "URGENCE",
      date: "DATE",
    },
    fields: {
      status: "STATUT",
      allStatuses: "Tous",
      allUrgencies: "Toutes",
      urgency: "URGENCE",
    },
    summary: {
      total: "Total",
      totalSub: "Demandes totales",
      pending: "En Attente",
      pendingSub: "À traiter",
      approved: "Approuvées",
      approvedSub: "Validées",
      rejected: "Rejetées",
      rejectedSub: "Refusées",
    },
    pagination: {
      showing: "Affichage de",
      to: "à",
      of: "sur",
      entries: "entrées",
      previous: "Précédente",
      next: "Suivante",
    },
  },
  acts: {
    overview: {
      title: "Actes & Diagnostics",
      subtitle:
        "Consultez les référentiels d'actes et de diagnostics standardisés utilisés pour l'analyse et les statistiques.",
      actsCard: {
        title: "Consulter les actes",
        description: "Parcourir le catalogue des actes médicaux standards.",
        countLabel: "{count} actes standards",
        link: "Accéder aux actes",
      },
      diagnosticsCard: {
        title: "Consulter les diagnostics",
        description: "Parcourir le catalogue des diagnostics standards.",
        countLabel: "{count} diagnostics standards",
        link: "Accéder aux diagnostics",
      },
    },
    standardCodes: {
      title: "Actes médicaux standards",
      add: "Ajouter un acte standard",
      infoBanner:
        "Information : Ces codes standards permettent aux auditeurs de regrouper les actes détaillés des hôpitaux en catégories standardisées pour faciliter l'analyse et les statistiques globales.",
      exportCsv: "Exporter CSV",
      searchPlaceholder: "Rechercher...",
      deleteConfirm: "Supprimer cet acte standard ?",
      empty: "Aucun acte standard trouvé",
      pagination: {
        showing: "Affichage de",
        to: "à",
        of: "sur",
        entries: "entrées",
        previous: "Précédente",
        next: "Suivante",
      },
      columns: {
        code: "Code",
        name: "Nom",
        category: "Catégorie",
        specialty: "Spécialité",
        description: "Description",
        actions: "Actions",
      },
      create: {
        title: "Ajouter un acte standard",
        cardTitle: "Nouvel acte standard",
        submit: "Enregistrer",
        categoryPlaceholder: "-- Sélectionner --",
        fields: {
          code: "CODE",
          name: "NOM",
          category: "CATÉGORIE",
          specialty: "SPÉCIALITÉ",
          description: "DESCRIPTION",
        },
        placeholders: {
          code: "Ex: COR30",
          name: "Ex: CODE REFRACTION CONSULTATION",
          specialty: "Spécialité (optionnel)",
          description: "Description détaillée (optionnel)",
        },
      },
      edit: {
        title: "Modifier un acte standard",
        cardTitle: "Modifier l'acte standard",
        submit: "Enregistrer",
        notFound: "Acte standard introuvable.",
        categoryPlaceholder: "-- Sélectionner --",
        fields: {
          code: "CODE",
          name: "NOM",
          category: "CATÉGORIE",
          specialty: "SPÉCIALITÉ",
          description: "DESCRIPTION",
        },
        placeholders: {
          code: "Ex: COR30",
          name: "Ex: CODE REFRACTION CONSULTATION",
          specialty: "Spécialité (optionnel)",
          description: "Description détaillée (optionnel)",
        },
      },
    },
    standardDiagnostics: {
      title: "Diagnostics standards",
      add: "Ajouter un diagnostic standard",
      infoBanner:
        "Information : Ces codes standards permettent aux auditeurs d'associer un diagnostic standardisé aux factures pour faciliter l'analyse et les statistiques globales.",
      exportCsv: "Exporter CSV",
      searchPlaceholder: "Rechercher...",
      deleteConfirm: "Supprimer ce diagnostic standard ?",
      empty: "Aucun diagnostic standard trouvé",
      pagination: {
        showing: "Affichage de",
        to: "à",
        of: "sur",
        entries: "entrées",
        previous: "Précédente",
        next: "Suivante",
      },
      columns: {
        code: "Code",
        name: "Nom",
        type: "Type",
        description: "Description",
        actions: "Actions",
      },
      create: {
        title: "Ajouter un diagnostic standard",
        cardTitle: "Nouveau diagnostic standard",
        submit: "Enregistrer",
        typePlaceholder: "-- Sélectionner --",
        fields: {
          code: "CODE",
          name: "NOM",
          type: "TYPE",
          description: "DESCRIPTION",
        },
        placeholders: {
          code: "Ex: 11",
          name: "Ex: ARYTMIE CARDIAQUE",
          description: "Description détaillée (optionnel)",
        },
      },
      edit: {
        title: "Modifier un diagnostic standard",
        cardTitle: "Modifier le diagnostic standard",
        submit: "Enregistrer",
        notFound: "Diagnostic standard introuvable.",
        typePlaceholder: "-- Sélectionner --",
        fields: {
          code: "CODE",
          name: "NOM",
          type: "TYPE",
          description: "DESCRIPTION",
        },
        placeholders: {
          code: "Ex: 11",
          name: "Ex: ARYTMIE CARDIAQUE",
          description: "Description détaillée (optionnel)",
        },
      },
    },
    hospitalActs: {
      title: "Actes médicaux par hôpital",
      infoBanner:
        "Information : Ce tableau affiche les actes médicaux que chaque hôpital a configurés dans sa grille tarifaire. Ces actes servent de référence pour les auditeurs.",
      exportCsv: "Exporter CSV",
      searchPlaceholder: "Rechercher...",
      noActsConfigured: "Aucun acte configuré",
      actsCount: "{count} ACTE(S)",
      view: "Voir",
      pagination: "Affichage de {from} à {to} sur {total} entrées",
      previous: "Précédente",
      next: "Suivante",
      filters: {
        actsLabel: "Filtrer par actes",
        all: "Tous les hôpitaux",
        withActs: "Avec actes configurés",
        withoutActs: "Sans actes configurés",
      },
      actions: {
        validateCategories: "Valider les catégories",
        aiAllGrids: "IA (toutes grilles)",
        reclassifyAi: "Reclassifier (IA)",
      },
      columns: {
        hospital: "Hôpital",
        actCount: "Nombre d'actes",
        actions: "Actions",
      },
      modal: {
        title: "Actes médicaux - {hospital}",
        close: "Fermer",
        columns: {
          code: "Code",
          label: "Libellé",
          careType: "Type de soin",
          cost: "Coût (USD)",
          delay: "Délai (j)",
        },
        careTypes: {
          nursing: "Nursing",
          consultation: "Consultation (générale, spécialisée)",
          surgery: "Chirurgie",
          imagingLab: "Imagerie, labo et diagnostic",
        },
      },
    },
    medicalActs: {
      pageTitle: "Gestion des Actes Médicaux",
      import: {
        title: "Import CSV/Excel",
        fileLabel: "FICHIER CSV",
        chooseFile: "Choisir un fichier",
        noFileSelected: "Aucun fichier choisi",
        formatHint: "Format: code, libelle, cout (avec en-têtes)",
        submit: "Importer",
        downloadExample: "Télécharger exemple CSV",
        duplicateHint: "Les codes en double seront ignorés",
        selectFileFirst: "Veuillez sélectionner un fichier CSV.",
        success: "Import simulé avec succès.",
      },
      create: {
        title: "Créer un acte médical",
        submit: "Créer",
        validationError: "Veuillez remplir tous les champs obligatoires.",
        duplicateCode: "Ce code existe déjà.",
        success: "Acte médical créé.",
        fields: {
          code: "CODE",
          label: "LIBELLÉ",
          cost: "COÛT (USD)",
        },
        placeholders: {
          code: "Ex: CONS001",
          label: "Ex: Consultation générale",
          cost: "Ex: 50.00",
        },
      },
      list: {
        title: "Mes actes médicaux",
        pendingBadge: "{count} À VALIDER",
        ai: "IA (~{count})",
        delete: "Supprimer",
        deleteSuccess: "Acte supprimé.",
        searchPlaceholder: "Code ou libellé...",
        pagination: "Affichage de {from} à {to} sur {total} entrées",
        previous: "Précédente",
        next: "Suivante",
        columns: {
          label: "LIBELLÉ",
          careType: "TYPE DE SOIN",
          cost: "COÛT",
          createdAt: "CRÉÉ LE",
          action: "ACTION",
        },
      },
      careTypes: {
        pharmacy: "Pharmacie",
        nursing: "Nursing",
        consultation: "Consultation",
        surgery: "Chirurgie",
        imagingLab: "Imagerie, labo et diagnostic",
      },
    },
    categoryValidation: {
      title: "Validation des catégories",
      exportCsv: "Exporter CSV",
      applyFilter: "Filtrer",
      allHospitals: "Tous",
      allCategories: "Toutes",
      fields: {
        hospital: "HÔPITAL",
        filter: "FILTRE",
        currentCategory: "CATÉGORIE ACTUELLE",
        search: "RECHERCHE",
      },
      searchPlaceholder: "Code ou libellé...",
      summary: {
        toValidate: "À valider",
        classified: "Classés (fiabilisés)",
        manuallyValidated: "Validés manuellement",
        lowConfidence: "Faible confiance",
        unclassified: "Non classés",
      },
      filterStatus: {
        toValidate: "À valider",
        classified: "Classé (fiabilisé)",
        manuallyValidated: "Validé manuellement",
        lowConfidence: "Faible confiance",
        unclassified: "Non classé",
      },
      approve: "Valider",
      reject: "Rejeter",
      processed: "Traité",
      results: {
        title: "Résultats",
        hint: "Sélectionnez un hôpital pour valider en masse.",
        ok: "OK",
        confidenceSource: {
          rule: "rule",
          ai: "ia",
        },
        columns: {
          hospital: "Hôpital",
          code: "Code",
          label: "Libellé",
          proposedCategory: "Catégorie proposée",
          confidence: "Confiance",
          actions: "Actions",
        },
      },
    },
  },
  statistics: {
    dashboardButton: "Tableau de bord",
    pageTitle: "Tableau de bord analytique",
    summary: "{admissions} admissions • {invoiced} USD facturés • {companies} entreprises • {hospitals} hôpitaux — Année {year}",
    badge: "Administration",
    auditBadge: "Audit",
    keyIndicators: "Indicateurs clés",
    indicators: {
      admissions: "Admissions 2026",
      invoicedAmount: "Montant facturé",
      avgCost: "Coût moy. / facture",
      companies: "Entreprises actives",
      hospitals: "Hôpitaux",
      employees: "Salariés actifs",
    },
    indicatorFooters: {
      thisYear: "Cette année",
      usdYear: "USD 2026",
      usd: "USD",
      active: "Actives",
      partners: "Partenaires",
      activeEmployees: "Actifs",
    },
    trends: {
      sectionTitle: "Tendances et répartitions",
      monthlyAdmissions: "Admissions mensuelles",
      monthlyInvoiced: "Montants facturés mensuels",
      admissionStatuses: "Statuts admissions",
      invoiceStatuses: "Statuts factures 2026",
      topMedicalActs: "Top 5 actes médicaux",
      last12Months: "12 derniers mois",
      months12: "12 mois",
      byFrequency2026: "Par fréquence 2026",
      admissionStatusLabels: {
        pending: "En attente",
        inProgress: "En cours",
        completed: "Terminé",
        transferred: "Transféré",
      },
      invoiceStatusLabels: {
        submitted: "Submitted",
        underReview: "Under Review",
        approved: "Approved",
      },
    },
    insights: {
      frequentDiagnostics: "Diagnostics fréquents",
      companyExpenses: "Dépenses par entreprise",
      topHospitals: "Top hôpitaux {year}",
      top8: "Top 8",
      year2026: "2026",
      admissionsCount: "{count} adm.",
      emptyTopHospitals: "Aucune admission sur l'année",
    },
    charts: "Graphiques",
    diseaseTitle: "Types de Maladies Fréquentes",
    legend: "Fréquence des maladies",
  },
  system: {
    backup: {
      description: "Gérez les sauvegardes de la plateforme et planifiez les exports de données.",
      createDescription: "Créez une sauvegarde complète ou partielle de la plateforme.",
      restoreDescription: "Restaurez les données à partir d'une sauvegarde existante.",
      exportInstruction: "Exportez une sauvegarde de la base de données au format SQL.",
      exportButton: "Exporter la sauvegarde",
      exportSuccess: "Sauvegarde SQL exportée avec succès.",
      importInstruction: "Importez un fichier .sql exporté par la sauvegarde.",
      chooseFile: "Choisir un fichier",
      noFileSelected: "Aucun fichier choisi",
      importButton: "Importer",
      importSuccess: "Sauvegarde importée avec succès.",
      importInvalidFile: "Veuillez sélectionner un fichier .sql valide.",
    },
    logs: {
      description: "Consultez l'historique des événements et activités du système.",
      breadcrumb: "Logs",
      historyTitle: "Historique des actions",
      columns: {
        id: "ID",
        date: "DATE",
        user: "UTILISATEUR",
        action: "ACTION",
      },
    },
    cache: {
      description: "Purgez et optimisez le cache applicatif pour améliorer les performances.",
      clearAll: "Vider tout le cache",
      clearAllSuccess: "Cache entièrement vidé.",
      cleanExpiredSuccess: "Entrées expirées supprimées.",
      clearOpcacheSuccess: "OPcache PHP vidé.",
      disableCacheSuccess: "Cache désactivé.",
      stats: {
        totalEntries: "Entrées Totales",
        validEntries: "Entrées Valides",
        expiredEntries: "Entrées Expirées",
        totalSize: "Taille Totale",
        usagePercent: "{percent} utilisé",
      },
      spaceUsage: {
        title: "Utilisation de l'espace",
      },
      quickActions: {
        title: "Actions Rapides",
        cleanExpired: "Nettoyer les entrées expirées",
        clearOpcache: "Vider OPcache PHP",
        disableCache: "Désactiver le cache",
      },
      entries: {
        title: "Entrées du Cache",
        columns: {
          key: "CLÉ",
          size: "TAILLE",
          created: "CRÉATION",
          expires: "EXPIRATION",
          ttl: "TTL",
          status: "STATUT",
          actions: "ACTIONS",
        },
        expired: "EXPIRÉ",
        deleteSuccess: "Entrée de cache supprimée.",
        empty: "Aucune entrée de cache.",
      },
    },
  },
  disputes: {
    title: "Litiges",
    create: "Créer un litige",
    newTitle: "Nouveau litige",
    submit: "Créer le litige",
    listPlaceholder: "Liste de tous les litiges à venir.",
    processedPlaceholder: "Liste des litiges traités à venir.",
    createForm: {
      backToList: "Retour à la liste",
      back: "Retour",
      infoBanner:
        "Information : Le litige sera créé avec le statut « En attente » et pourra être traité par un auditeur.",
    },
    list: {
      pageTitle: "Tous les litiges",
      createButton: "Créer un litige",
      searchPlaceholder: "Rechercher...",
      exportCsv: "Exporter CSV",
      allStatuses: "Tous les statuts",
      empty: "Aucun litige trouvé",
      emptyRegistered: "Aucun litige enregistré pour le moment.",
      statuses: {
        inProgress: "En cours",
        resolved: "Traité",
        rejected: "Rejeté",
        closed: "Clôturé",
      },
      columns: {
        id: "ID",
        date: "Date",
        hospital: "Hôpital",
        company: "Entreprise",
        amount: "Montant",
        status: "Statut",
        actions: "Actions",
      },
      actions: {
        view: "Voir",
      },
    },
    inProgress: {
      cardTitle: "Litiges nécessitant un traitement",
      emptySuccess: "Aucun litige en attente. Tous les litiges ont été traités.",
      viewAll: "Voir tous les litiges",
    },
    fields: {
      invoice: "FACTURE CONCERNÉE",
      invoicePlaceholder: "-- Sélectionner une facture --",
      invoiceHint: "Sélectionnez la facture concernée par ce litige.",
      description: "DESCRIPTION DU LITIGE",
      descriptionPlaceholder: "Décrivez en détail le problème constaté...",
      descriptionHelpIntro: "Fournissez une description détaillée incluant :",
      descriptionHelpBullets: {
        problem: "Le problème exact identifié",
        amounts: "Les montants ou actes concernés",
        documents: "Les documents de référence",
        other: "Toute information pertinente",
      },
    },
  },
  auditReports: {
    list: {
      title: "Rapports d'audit",
      subtitle: "Tous les rapports d'audit enregistrés",
      submitButton: "Soumettre un rapport",
      searchPlaceholder: "Rechercher…",
      reset: "Réinitialiser",
      exportCsv: "Exporter CSV",
      loading: "Chargement…",
      empty: "Aucun rapport d'audit disponible.",
      view: "Voir le rapport",
      columns: {
        id: "ID",
        auditDate: "Date audit",
        invoice: "Facture N°",
        hospital: "Hôpital",
        company: "Entreprise",
        auditor: "Auditeur",
        originalAmount: "Montant original",
        basketTotal: "Montant panier",
        status: "Statut",
        actions: "Actions",
      },
    },
    detail: {
      title: "Rapport d'audit",
      loading: "Chargement du rapport…",
      notFound: "Rapport introuvable.",
      loadError: "Impossible de charger le rapport.",
      backToList: "Retour à la liste",
      viewInvoice: "Voir la facture",
      print: "Imprimer",
      auditDate: "Date d'audit",
      invoice: "Facture N°",
      status: "Statut",
      auditor: "Auditeur",
      hospital: "Hôpital",
      company: "Entreprise",
      financialAnalysis: "Analyse financière",
      originalAmount: "Montant original",
      basketTotal: "Montant panier",
      difference: "Différence",
      note: "Note",
      basketTitle: "Détail des actes sélectionnés",
      basketCode: "Code",
      basketLabel: "Libellé",
      basketCost: "Coût (USD)",
      total: "Total",
      diagnosis: "Diagnostic",
      reportContent: "Rapport d'audit",
      noReportContent: "Aucun contenu de rapport.",
    },
    submit: {
      title: "Soumettre un rapport d'audit",
      subtitle: "Rédigez le rapport associé à une facture auditée.",
      backToList: "Retour à la liste",
      invoiceId: "ID facture",
      invoiceIdPlaceholder: "Ex. 42",
      report: "Rapport",
      reportPlaceholder: "Saisissez le contenu du rapport d'audit…",
      submit: "Soumettre le rapport",
      saving: "Enregistrement…",
      validationError: "Facture et rapport obligatoires.",
      saveError: "Impossible d'enregistrer le rapport.",
      successMessage: "Rapport soumis avec succès.",
    },
  },
  invoices: {
    billing: "Facturation",
    globalTitle: "Génération Facture Globale",
    filtersTitle: "Filtres de Génération",
    filtersSubtitle: "Sélectionnez les critères pour générer votre facture globale",
    selectCompany: "Sélectionner une entreprise",
    month: "MOIS",
    year: "ANNÉE",
    dateRange: "Fourchette de dates (alternative au mois/année)",
    startDate: "DATE DE DÉBUT",
    startDateHint: "Sélectionnez la date de début de la période",
    endDate: "DATE DE FIN",
    endDateHint: "Sélectionnez la date de fin de la période",
    systemId: "ID SYS (MATRICULE)",
    systemIdHint: "Entrez le matricule système pour filtrer par patient spécifique",
    provider: "PRESTATAIRE",
    allProviders: "Tous les prestataires",
    actType: "TYPE D'ACTE MÉDICAL",
    generate: "Générer la Facture Globale",
    submit: {
      title: "Soumettre une facture",
      cardTitle: "Nouvelle facture",
      steps: {
        provider: "Prestataire & Entreprise",
        amounts: "Montants",
        summary: "Récapitulatif",
      },
      next: "Suivant",
      previous: "Précédent",
      submit: "Soumettre la facture",
      success: "Votre facture a été soumise avec succès. Elle apparaîtra dans les factures en attente.",
      viewPending: "Voir les factures en attente",
      summaryTitle: "Vérifiez avant de soumettre",
      statusBannerPrefix: "La facture sera soumise avec le statut",
      statusBannerStatus: "En attente d'audit.",
      fields: {
        provider: "Prestataire",
        providerPlaceholder: "— Sélectionnez un prestataire —",
        company: "Entreprise",
        companyPlaceholder: "— Sélectionnez une entreprise —",
        periodFrom: "Période du",
        periodTo: "Au",
        datePlaceholder: "jj/mm/aaaa",
        providerReference: "Réf. facture prestataire",
        providerReferencePlaceholder: "Ex: 2602-104239",
        attachment: "Fichier facture (PDF / JPG / PNG)",
        attachmentHint: "Obligatoire (forfait et hors forfait). Max 20 Mo.",
        chooseFile: "Choisir un fichier",
        noFileSelected: "Aucun fichier choisi",
        totalAmount: "Montant total facture",
        totalAmountHint: "Montant brut figurant sur la facture du prestataire.",
        rsspAmount: "Montant RSSP",
        rsspAmountHint: "Part reversée à la caisse nationale (laisser vide si aucune).",
        currency: "Devise de la facture",
        currencyHint: "La comparaison des actes se fera dans cette devise.",
        currencyUsd: "USD ($) — dollars",
        currencyCdf: "CDF (FC) — francs congolais",
        exchangeRate: "Taux FC → USD",
        exchangeRateHint: "Taux par défaut de l'hôpital (modifiable si besoin).",
        notes: "Notes (optionnel)",
        notesPlaceholder: "Remarques sur cette facture...",
        amountsBannerTitle: "Facture hors forfait",
        amountsBannerText:
          "— Actes non couverts par le package. Saisissez le montant réel figurant sur la facture du prestataire.",
      },
      summary: {
        provider: "Prestataire",
        company: "Entreprise",
        convention: "Convention",
        treatmentMode: "Mode traitement",
        invoiceNature: "Nature facture",
        period: "Période",
        reference: "Réf. prestataire",
        currency: "Devise",
        exchangeRate: "Taux FC/USD",
        invoiceAmount: "Montant facture",
        rsspPortion: "dont RSSP",
        amountToPay: "Montant à payer",
        file: "Fichier",
        notes: "Notes",
        noConvention: "Aucune convention",
        outOfPackage: "Hors forfait",
      },
    },
    pendingAudit: {
      title: "Factures en attente d'audit",
      submitInvoice: "Soumettre une facture",
      searchPlaceholder: "Rechercher...",
      exportExcel: "Exporter Excel",
      exportPdf: "Exporter PDF",
      download: "Télécharger",
      empty: "Aucune facture en attente",
      statuses: {
        inReview: "EN EXAMEN",
        submitted: "SOUMISE",
        pendingAudit: "EN ATTENTE D'AUDIT",
      },
      columns: {
        id: "ID",
        provider: "Prestataire / Hôpital",
        company: "Entreprise",
        nature: "Nature",
        invoice: "Facture",
        status: "Statut",
        createdAt: "Date de création",
        actions: "Actions",
      },
      filters: {
        hospital: "Hôpital",
        company: "Entreprise",
        status: "Statut",
        allHospitals: "Tous",
        allCompanies: "Toutes",
        allStatuses: "En attente (tous)",
      },
    },
    all: {
      title: "Factures",
      searchPlaceholder: "Rechercher...",
      exportExcel: "Exporter Excel",
      exportPdf: "Exporter PDF",
      download: "Télécharger",
      empty: "Aucune facture trouvée",
      allStatuses: "Tous statuts",
      statuses: {
        inReview: "EN EXAMEN",
        submitted: "SOUMISE",
        pendingAudit: "EN ATTENTE D'AUDIT",
        approved: "APPROUVÉE",
        rejected: "REJETÉE",
      },
      columns: {
        id: "ID",
        date: "Date",
        hospital: "Hôpital",
        company: "Entreprise",
        nature: "Nature",
        amount: "Montant",
        status: "Statut",
        actions: "Actions",
      },
      actions: {
        view: "Voir",
        edit: "Modifier",
      },
      pagination: {
        showing: "Affichage de",
        to: "à",
        of: "sur",
        entries: "entrées",
        previous: "Précédente",
        next: "Suivante",
      },
    },
    enterpriseAll: {
      searchPlaceholder: "Rechercher...",
      exportCsv: "Exporter CSV",
      download: "Télécharger",
      empty: "Aucun relevé de facturation publié par l'administration.",
      allStatuses: "Tous statuts",
      statuses: {
        submitted: "SOUMISE",
        inReview: "EN EXAMEN",
        approved: "APPROUVÉE",
        rejected: "REJETÉE",
      },
      columns: {
        id: "ID",
        hospital: "Hôpital",
        company: "Entreprise",
        nature: "Nature",
        invoice: "Facture",
        status: "Statut",
        actions: "Actions",
      },
      actions: {
        view: "Voir",
      },
      pagination: {
        showing: "Affichage de",
        to: "à",
        of: "sur",
        entries: "entrées",
        previous: "Précédente",
        next: "Suivante",
      },
    },
    hospitalView: {
      searchPlaceholder: "Rechercher...",
      exportCsv: "Exporter CSV",
      download: "Télécharger",
      empty: "Aucune facture trouvée",
      allStatuses: "Tous statuts",
      statuses: {
        submitted: "SOUMISE",
        inReview: "EN EXAMEN",
        approved: "APPROUVÉE",
      },
      columns: {
        id: "ID",
        company: "Entreprise",
        nature: "Nature",
        invoice: "Facture",
        status: "Statut",
        actions: "Actions",
      },
      actions: {
        view: "Voir",
      },
      pagination: {
        showing: "Affichage de",
        to: "à",
        of: "sur",
        entries: "entrées",
        previous: "Précédente",
        next: "Suivante",
      },
    },
    enterpriseDetail: {
      pageTitle: "Facture #{id}",
      billingPageTitle: "Relevé #{id}",
      notFound: "Facture introuvable.",
      billingNotFound: "Relevé introuvable.",
      download: "Télécharger",
      print: "Imprimer",
      back: "Retour",
      sections: {
        info: "Informations de la facture",
        acts: "Actes médicaux",
        document: "Document Facture",
        billingDocuments: "Pièces jointes du relevé",
        tracking: "Suivi",
      },
      fields: {
        patientEmployee: "Patient (Employé)",
        company: "Entreprise",
        hospital: "Prestataire / Hôpital",
        treatmentType: "Type de traitement",
        invoiceNature: "Nature de la facture",
        providerReference: "Référence prestataire",
        period: "Période",
        submissionNotes: "Notes de soumission",
        number: "Numéro",
        submittedAt: "Soumise le",
        totalAmount: "Montant total facturé",
        coveredAmount: "Part prise en charge",
        coveredAmountHint: "Montant couvert / approuvé pour le client (après réfraction)",
        currentStatus: "Statut actuel",
      },
      treatmentTypes: {
        forfaitaire: "FORFAITAIRE",
        standard: "STANDARD",
      },
      invoiceNatures: {
        forfait_mensuel: "FORFAIT MENSUEL",
        hors_forfait: "HORS FORFAIT",
      },
      glossary: {
        status:
          "Statut du workflow : SOUMISE (déposée), EN EXAMEN (audit), APPROUVÉE ou REJETÉE.",
        treatment:
          "Type de traitement conventionnel : STANDARD (à l’acte) ou FORFAITAIRE (forfait).",
        nature:
          "Nature de la facture (si renseignée) : FORFAIT MENSUEL ou HORS FORFAIT.",
      },
      actColumns: ["CODE", "LIBELLÉ", "COÛT", "DATE"],
      emptyActs: "Aucun acte enregistré",
      emptyActsForfait: "Actes facturés au forfait",
      totalBilled: "TOTAL FACTURÉ",
      documentHint: "Aperçu du document joint à la facture",
      noAttachments: "Aucune pièce jointe sur ce relevé.",
      billingPreviewHint: "Aperçu disponible pour les PDF et images jointes.",
      billingCompanyNotice:
        "Relevé Safecheck pour votre entreprise. Les documents internes prestataires ne sont pas affichés.",
    },
    enterpriseApproved: {
      download: "Télécharger",
      empty: "Aucun relevé publié à régler.",
      status: "APPROUVÉE",
      columns: {
        id: "ID",
        hospital: "Hôpital",
        company: "Entreprise",
        nature: "Nature",
        invoice: "Facture",
        status: "Statut",
        actions: "Actions",
      },
      actions: {
        view: "Voir",
      },
      pagination: {
        showing: "Affichage de",
        to: "à",
        of: "sur",
        entries: "entrées",
        previous: "Précédente",
        next: "Suivante",
      },
    },
    approved: {
      title: "Factures approuvées",
      searchPlaceholder: "Rechercher...",
      exportCsv: "Exporter CSV",
      empty: "Aucune facture approuvée.",
      status: "APPROUVÉE",
      columns: {
        id: "ID",
        date: "Date",
        hospital: "Hôpital",
        company: "Entreprise",
        nature: "Nature",
        amount: "Montant",
        status: "Statut",
        actions: "Actions",
      },
      actions: {
        view: "Voir",
      },
      pagination: {
        showing: "Affichage de",
        to: "à",
        of: "sur",
        entries: "entrées",
        previous: "Précédente",
        next: "Suivante",
      },
    },
    rejected: {
      title: "Factures rejetées",
      searchPlaceholder: "Rechercher...",
      exportCsv: "Exporter CSV",
      empty: "Aucune facture rejetée",
      status: "REJETÉE",
      columns: {
        id: "ID",
        date: "Date",
        hospital: "Hôpital",
        company: "Entreprise",
        nature: "Nature",
        amount: "Montant",
        status: "Statut",
        actions: "Actions",
      },
      actions: {
        view: "Voir",
      },
    },
    audited: {
      title: "Factures auditées",
      searchPlaceholder: "Rechercher...",
      allStatuses: "Tous statuts",
      download: "Télécharger",
      empty: "Aucune facture auditée.",
      statusApproved: "APPROUVÉE",
      statusRejected: "REJETÉE",
      actsDiagnostics: "Actes & Diagnostic",
      columns: {
        id: "ID",
        hospital: "Hôpital",
        company: "Entreprise",
        nature: "Nature",
        invoice: "Facture",
        status: "Statut",
        actions: "Actions",
      },
      actions: {
        view: "Voir",
        edit: "Modifier",
      },
      pagination: {
        showing: "Affichage de",
        to: "à",
        of: "sur",
        entries: "entrées",
        previous: "Précédente",
        next: "Suivante",
      },
    },
    list: {
      searchPlaceholder: "Rechercher...",
      exportCsv: "Exporter CSV",
      view: "Voir la facture",
      empty: "Aucune facture trouvée",
      statuses: {
        pending: "EN ATTENTE",
        approved: "APPROUVÉE",
        rejected: "REJETÉE",
      },
      variants: {
        all: {
          title: "Toutes les factures",
          subtitle: "Vue complète de toutes les factures de la plateforme.",
        },
        pending: {
          title: "Factures en attente",
          subtitle: "Factures soumises en attente d'examen ou de validation.",
        },
        approved: {
          title: "Factures approuvées",
          subtitle: "Factures validées par les auditeurs.",
        },
        rejected: {
          title: "Factures rejetées",
          subtitle: "Factures refusées nécessitant une correction.",
        },
      },
      columns: {
        reference: "Référence",
        hospital: "Hôpital",
        company: "Entreprise",
        amount: "Montant",
        period: "Période",
        submittedDate: "Date soumission",
        delay: "Délai",
        status: "Statut",
        actions: "Actions",
      },
      fields: {
        dateFrom: "À partir du",
        dateFromHint: "Inclut ce jour et les suivants",
        dateTo: "Jusqu'au",
        dateToHint: "Inclut ce jour (laisser vide = pas de fin)",
        hospital: "Hôpital",
        company: "Entreprise",
        allHospitals: "Tous les hôpitaux",
        allCompanies: "Toutes les entreprises",
      },
    },
  },
} as const;
